var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverFlowTilesView = function SvgOverFlowTilesView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9799",
    transform: "translate(-35 -542)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 58",
    width: 44,
    height: 44,
    rx: 6,
    transform: "translate(35 542)",
    fill: "#59da5d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 68",
    d: "M45 552h10v10H45z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 69",
    d: "M45 566h10v10H45z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 70",
    d: "M59 552h10v10H59z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 71",
    d: "M59 566h10v10H59z"
  })))));
};
export default SvgOverFlowTilesView;